import { render, staticRenderFns } from "./ChannelResult.vue?vue&type=template&id=5df68a06&"
import script from "./ChannelResult.vue?vue&type=script&lang=ts&"
export * from "./ChannelResult.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports